module.exports = __webpack_public_path__ + "img/rooms.8ef7aecf.jpg";